export default "__VITE_ASSET__BgP8U8PB__"